import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DateFormat, TimeFormat } from "../types/dateTimeFormats";
import { MeasurementSystem } from "../types/measurementSystems";

export type RegionSettingsPerUserSlice = {
  loading: boolean;
  longDateFormat: DateFormat | null;
  longDateFormatId: number | null;
  longTimeFormat: TimeFormat | null;
  longTimeFormatId: number | null;
  measurementSystem: MeasurementSystem | null;
  measurementSystemId: number | null;
  regionId: number | null;
  shortDateFormat: DateFormat | null;
  shortDateFormatId: number | null;
  shortTimeFormat: TimeFormat | null;
  shortTimeFormatId: number | null;
  timeZone: unknown | null;
  timeZoneId: number | null;
  userId: number | null;
};

const initialState: RegionSettingsPerUserSlice = {
  loading: false,
  longDateFormat: null,
  longDateFormatId: null,
  longTimeFormat: null,
  longTimeFormatId: null,
  measurementSystem: null,
  measurementSystemId: null,
  regionId: null,
  shortDateFormat: null,
  shortDateFormatId: null,
  shortTimeFormat: null,
  shortTimeFormatId: null,
  timeZone: null,
  timeZoneId: null,
  userId: null
};

const regionSettingsPerUserSlice = createSlice({
  name: "regionSettingsPerUser",
  initialState,
  reducers: {
    startGetRegionSettingsPerUser(state) {
      state.loading = true;
    },
    getRegionSettingsPerUserSuccess(state, action: PayloadAction<any>) {
      state.loading = false;
      state.longDateFormat = action.payload.longDateFormat;
      state.longDateFormatId = action.payload.longDateFormatId;
      state.longTimeFormat = action.payload.longTimeFormat;
      state.longTimeFormatId = action.payload.longTimeFormatId;
      state.measurementSystem = action.payload.measurementSystem;
      state.measurementSystemId = action.payload.measurementSystemId;
      state.regionId = action.payload.regionId;
      state.shortDateFormat = action.payload.shortDateFormat;
      state.shortDateFormatId = action.payload.shortDateFormatId;
      state.shortTimeFormat = action.payload.shortTimeFormat;
      state.shortTimeFormatId = action.payload.shortTimeFormatId;
      state.timeZone = action.payload.timeZone;
      state.timeZoneId = action.payload.timeZoneId;
      state.userId = action.payload.userId;
    },
    getRegionSettingsPerUserFailure() {
      return initialState;
    },
    //NOTE: This action is never used
    setRegionSettingsPerUser(state, action: PayloadAction<any>) {
      state.longDateFormat = action.payload.longDateFormat;
      state.longDateFormatId = action.payload.longDateFormatId;
      state.longTimeFormat = action.payload.longTimeFormat;
      state.longTimeFormatId = action.payload.longTimeFormatId;
      state.measurementSystem = action.payload.measurementSystem;
      state.measurementSystemId = action.payload.measurementSystemId;
      state.regionId = action.payload.regionId;
      state.shortDateFormat = action.payload.shortDateFormat;
      state.shortDateFormatId = action.payload.shortDateFormatId;
      state.shortTimeFormat = action.payload.shortTimeFormat;
      state.shortTimeFormatId = action.payload.shortTimeFormatId;
      state.timeZone = action.payload.timeZone;
      state.timeZoneId = action.payload.timeZoneId;
      state.userId = action.payload.userId;
    }
  }
});

export const {
  startGetRegionSettingsPerUser,
  getRegionSettingsPerUserSuccess,
  getRegionSettingsPerUserFailure
} = regionSettingsPerUserSlice.actions;

export default regionSettingsPerUserSlice.reducer;
